import API from "serviceshift-ui/api-client";

export default {
    fetchChoices(_, choice) {
        return API.makeRequest(`/v2/choices/${choice}`, {
            method: "GET"
        });
    }
}